import {DatePipe} from '@angular/common';
import {Component, ElementRef, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {switchMap} from 'rxjs/operators';
import {EntryType, ModalTypes, QuestionType, RouterLinks, Superflow} from '../../constants';
import {Question, ShoppingCartItem} from '../../models/underwriter.model';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {QuestionFlowSessionStore} from '../../questions/state/question-flow-session.store';
import {ShoppingCartQuery} from '../../questions/state/shopping-cart-query';
import {ShoppingCartStore} from '../../questions/state/shopping-cart-store';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ModalService} from '../../services/modal.service';
import {SidebarService} from '../../services/sidebar-service';
import {UserStore} from '../../../authentication/state/user.store';
import {ClaimsService} from '../../../claim/services/claims.service';
import { StorageService } from '../../services/storage.service';

declare var $: any;

@Component({
    selector: 'app-claim-edit-modal',
    templateUrl: './claim-edit-modal.component.html',
    styleUrls: ['./claim-edit-modal.component.scss'],
    standalone: false
})
export class ClaimEditModalComponent implements OnInit {

  questions: Question[] = [];
  childrenQuestions: Question[] = [];
  input_cart_item: any = {};
  loading = false;
  isSidebarLoading = false;
  groups: any[] = [];
  claim_name: string;
  claim_details: any = {};
  event_details: any;
  session_details: any;
  date: any;
  address: any;
  isSavingData = false;
  QuestionType = QuestionType;
  ModalTypes = ModalTypes;
  modal_type: ModalTypes;
  cart_item: ShoppingCartItem;
  shoppingCartItems: any[] = [];
  police_report: ShoppingCartItem;
  session_id: string;
  constructor(private globalQuestionService: GlobalQuestionService,
    private sidebarService: SidebarService,
    private datePipe: DatePipe,
    private sessionQuery: QuestionFlowSessionQuery,
    private sessionStore: QuestionFlowSessionStore,
    private userStore: UserStore,
    private claimsService: ClaimsService,
    private shoppingCartQuery: ShoppingCartQuery,
    private shoppingCartStore: ShoppingCartStore,
    private router: Router,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private el: ElementRef,
    private storageService: StorageService) {
      this.route.queryParams.subscribe(params => {
        this.session_id = params.session_id;
      })
    }

  ngOnInit(): void {
    if (this.session_id) {
      // Arriving with only a session_id (e.g. a direct/notification link) - the shared
      // session store was never seeded by claims-landing's editClaim(), so category_id would
      // stay at its default of 0 and break every downstream call (getQuestionGrouping etc.)
      // that reads it. dbo.getClaims already supports filtering by session_id, so use it to
      // recover category_id/css before anything else runs.
      this.resumeClaimSession(this.session_id);
    }
    else {
      this.session_details = this.sessionQuery.getValue();
      this.getClaim();
    }

    this.populateSidebar();

    this.modalService.claimsEditModalMobileModalObservable
      .subscribe(x => {
        if (x) {
          $('#modal-submenu').modal('show');
        } else {
          $('#modal-submenu').modal('hide');
        }
      });

  }

  resumeClaimSession(session_id: string): void {
    const person_id = this.userStore.getValue()?.person_id;
    this.claimsService.getClaims(person_id, session_id).subscribe((claims: any[]) => {
      const claim = claims?.[0];
      if (claim) {
        // mirrors claims-landing.editClaim()'s update shape, so this route behaves the same
        // whether the modal was entered from the claims list or from a direct session_id link.
        this.sessionStore.update({
          session_id,
          category_id: claim.product_category_id,
          css: claim.category_class,
          flow_id: 14,
          superflow_id: Superflow.personal_claim
        });
      }
      this.session_details = this.sessionQuery.getValue();
      this.getClaim(session_id);
    });
  }

  getClaim(session_id: string = '') {
    this.globalQuestionService.evaluateClaimCompletionStatus(session_id)
      .pipe(switchMap(() => this.globalQuestionService.getClaim(session_id)))
      .subscribe((c: any[]) => {
        if (!c?.length) {
          return;
        }
        
        this.claim_details.claim_id = c[0]?.claim_id;
        this.claim_details.claim_name = c[0]?.claim_name;
        this.claim_details.claim_status = c[0]?.claim_status;
        this.claim_details.policy_id = c[0]?.policy_id;
        this.claim_details.version_id = c[0]?.version_id;
        this.claim_details.claim_version_id = c[0]?.claim_version_id;
        this.claim_details.claim_completion_status_id = c[0]?.claim_completion_status_id;

        // items may already have been built before this resolved - backfill the name
        if (this.claim_details.claim_name && this.event_details?.items?.length) {
          this.event_details.items.forEach((i: any) => i.name = this.claim_details.claim_name);
        }
        
      });
  }

  ngAfterViewInit(): void {
    const activeItem = this.shoppingCartQuery.getActive();
    
    //console.log('Shopping Cart:: ' + JSON.stringify(this.shoppingCartQuery.getAll()));
    if (activeItem) {
      this.input_cart_item = activeItem;
    } else {
      
      if (!this.input_cart_item) {
        this.input_cart_item = this.getEventDetailsItem();
      } else {
        if (Object.keys(this.input_cart_item).length === 0) {
          this.input_cart_item = this.getEventDetailsItem();
          console.log(this.input_cart_item)
        }
      }
    }
    if (this.input_cart_item){
      this.activateItem(this.input_cart_item);
    }
    
  }

  back(): void {
    this.globalQuestionService.evaluateClaimCompletionStatus()
      .subscribe(() => {
        const route = this.storageService.get('previous-document-page', 'flow');
        if (route) {
          this.router.navigate([`/${route}`]);
        } else {
          this.router.navigate([`/${RouterLinks.ClaimsLanding}`]);
        }
      });
  }

  save(): void {
    console.log('Claim Details::: ' + JSON.stringify(this.claim_details));
    this.globalQuestionService.evaluateClaimCompletionStatus()
      .pipe(switchMap(() => this.globalQuestionService.updateClaim2(
        this.claim_details?.claim_id, this.claim_details?.claim_version_id, 1
      )))
      .subscribe({
        next: (result: any) => {
          if (!result) {
            return;
          }
          const route = this.storageService.get('previous-document-page', 'flow');
          this.router.navigate([route ? `/${route}` : `/${RouterLinks.ClaimsLanding}`]);
        },
        error: (error) => {
          console.log(`Error occurred: ${error}`);
        }
      });
  }

  getItemStatus(progress: any, hasskipped: any): string {
    if (progress < 1) {
      return 'pending';
    } else {
      if (hasskipped === 1) {
        return 'pending';
      } else {
        return 'complete';
      }
    }
  }

  onRemoveItemChange(value: any): void {
    if (value?.item?.class_id && value?.item?.item_id) {
      this.removeItem(value?.item?.class_id, value?.item?.item_id);
    }
  }

  removeItem(class_id: any, item_id: string): void {
    if(class_id === 0 || item_id === '0') return;
    this.globalQuestionService.spinner(true);
    const session_details = this.sessionQuery.getValue();

    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('product_class_id', class_id);
    parameters.set('item_id', item_id);

    this.globalQuestionService.runCommandNew('removeItem', parameters)
      .subscribe(x => {

        this.populateSidebar();

      });
  }

  getEventDetailsItem(): any {
    if(this.event_details)
      return this.event_details.items[0];
    return {};
  }

  // '{"streetAddress":"68 Melville Road","suburb":"Illovo",...}' -> '68 Melville Road, Illovo, Sandton 2196'
  formatEventLocation(parts: string[]): string {
    for (const part of parts) {
      if (!part?.trim().startsWith('{')) {
        continue;
      }
      try {
        const address = JSON.parse(part);
        const cityLine = [address.city, address.postalCode].filter(x => x).join(' ');
        return [address.streetAddress, address.suburb, cityLine].filter(x => x).join(', ');
      } catch {
      }
    }
    return '';
  }

  // '2026-07-20' -> 'Jul 20, 2026'
  formatEventDate(parts: string[]): string {
    for (const part of parts) {
      const dateSplit = /^(\d{4})-(\d{2})-(\d{2})$/.exec(part?.trim());
      if (!dateSplit) {
        continue;
      }
      const [, year, month, day] = dateSplit;
      const startDate = new Date(+year, +month - 1, +day);
      if (!isNaN(startDate.getTime())) {
        return this.datePipe.transform(startDate, 'MMM dd, yyyy');
      }
    }
    return '';
  }

  populateSidebar(): any {
    this.groups = [];
    this.event_details = null;
    this.isSidebarLoading = true;

    this.globalQuestionService.getShoppingCart(0)
    .subscribe((shoppingCartItems: ShoppingCartItem[]) => {
      this.isSidebarLoading = false;
      if (!shoppingCartItems?.length) {
        this.globalQuestionService.spinner(false);
        return;
      }
      
      this.shoppingCartStore.set(shoppingCartItems);
      
      const cartItems = shoppingCartItems;
      const groupsDict: {} = cartItems?.reduce((r: any, a: any) => {
        r[a.class_id] = [...r[a.class_id] || [], a];
        return r;
      }, {});
      
      const groupsArray = Object.entries(groupsDict);
      
      groupsArray?.forEach((item: any) => {
        let items = [];
        const entries = item[1]; // item[1];

        entries?.forEach((entry: any) => {
          
          const stageName = entry.entry_type;
          
          let status = 'inactive';
          if (entry.active === 1) {
            status = 'active';
          }
          if (entry.progress === 1) {
            status = 'complete';
          }
          switch (stageName) {
            case 'event_details':
              items = [];
              
              const event_description = entry?.description?.split('|');
              if (event_description) {
                const name = event_description[0];
                // the fields after the name are not in a fixed order, so match them
                // by content rather than by index
                const location = this.formatEventLocation(event_description);
                const date = this.formatEventDate(event_description);

                // the description's first field is a question answer, which can be an internal
                // sentinel such as 'Multiple answers' - prefer the actual claim name
                items.push({name: this.claim_details?.claim_name || name, location: location, date: date, shoppingcart_id: entry?.shoppingcart_id, entry_type: entry.entry_type, item_id: entry.item_id, flow_id: entry.flow_id, class_id: entry.class_id});
                this.claim_name = name;
              }
              const ev_group = {group_type: this.getEntryType('event_details_header')[0]?.description, entry_type: stageName, items, status, percentage: `${entry.progress * 100}%`};
              this.event_details = ev_group;
              break;
            case 'class_header':
              items = this.getItemsByClassId(entries, entry.class_id);
              const class_group = { group_type: stageName, group_class: entry.class_id, group_name: entry.class_name, items, status, percentage: `${entry.progress * 100}%` };
              this.groups.push(class_group);
              break;
            case 'police_report_details':
              this.police_report = entry;
              break;
            default:
              break;
          }
        });
      });
      //if (this.groups.length === 0) {
        const activeItem = shoppingCartItems?.find(f => f?.entry_type === 'event_details');

        if (activeItem) {
          this.shoppingCartStore.setActive(activeItem.shoppingcart_id);
          this.activateItem(activeItem);
        }
      //}
      this.globalQuestionService.spinner(false);
    });




  }

  getEntryType(entry_type: string): any {
    const cartItems = this.shoppingCartQuery.getAll();

    return cartItems.filter((entry: any) =>
      entry.entry_type === entry_type);
  }

  getItemsByClassId(entries: any[], class_id: number): any {
    return entries?.filter(entry => entry.entry_type === 'class_item' && entry.class_id === class_id);
  }

  formatItemDescription(description: string, type: number): string {
    const splitDescription = description?.split('|');
    if (splitDescription) {
      switch (type) {
        case 1:
          return splitDescription[0];
        case 2:
          return splitDescription[1];
        default:
          return '';
      }
    }
    return '';
  }

  activateItem(item: any): any {
    if(!item) return;
    this.shoppingCartStore.setActive(item.shoppingcart_id);
    this.cart_item = item;
    switch (item.entry_type) {
      case EntryType.event_details:
        this.modal_type = ModalTypes.event_details;
        break;
      case EntryType.class_item:
        this.modal_type = ModalTypes.item_details;
        break;
      case EntryType.police_report_details:
        this.modal_type = ModalTypes.police_report_details;
        break;
      default:
        this.modal_type = ModalTypes.event_details;
        break;
    }
    this.modalService.setClaimsEditModalMobileModalSubject(false);
  }

  populateSideColl(): void {
    this.globalQuestionService.getShoppingCart(0)
      .subscribe((summary: any[]) => {
        
        const event_details = summary.find((entry: any) => entry.entry_type === 'event_details');

        const event_description = event_details?.description?.split('|');
        if (event_description) {
          // the description's first field is a question answer, which can be empty or an
          // internal sentinel such as 'Multiple answers' - prefer the actual claim name
          this.claim_name = this.claim_details?.claim_name || event_description[0];

          const dateSplit = event_description[2]?.split('/');
          if (dateSplit?.length === 3) {
            const year = dateSplit[2];
            const month = dateSplit[1];
            const day = dateSplit[0];

            const startDate = new Date(+year, +month - 1, +day);
            if (!isNaN(startDate.getTime())) {
              this.date = this.datePipe.transform(startDate, 'MMM dd, yyyy');
            }
          }

          if (event_description[1]) {
            try {
              const address = JSON.parse(event_description[1]);
              this.address = `${address.streetAddress}, ${address.suburb}, ${address.city}, ${address.postalCode}`;
            } catch {
            }
          }
        }
      });
  }

  getResponses(class_id: any, item_id: any): any {
    this.globalQuestionService.getResponses()
      .subscribe(r => {
        let questions: Question[];
        questions = r;
        
        if (questions?.length) {
          this.questions = [];
          this.childrenQuestions = [];
        }

        for (const q of questions) {
          if (q.answer && q?.item_id?.toString() === item_id?.toString() && q?.product_class_id?.toString() === class_id?.toString()) {
            if (q?.parent_control) {
              this.childrenQuestions.push(q);
              const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
              if (parentQuestion && !this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id)) {
                this.questions.push(parentQuestion);
              }
            } else {
              if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id)) {
                this.questions.push(q);
              }
            }
          }
        }
        this.loading = false;
      });
  }

  closeSubModal(): void {
    this.modalService.setClaimsEditModalMobileModalSubject(false);
  }

}
